<div class="parent-modal">
    <div class="empty-status-body">
        <div class="empty-status">
          <div class="empty-status-msg">
            <div class="image-center">
                <mwc-spin [mwcIndicator]="customSpinTpl" mwcSimple ></mwc-spin>
            </div>
            <div>
              <!-- <div class="mwc-text-lg-semibold mwc-color-gray-900">Oops, Something Went Wrong!</div> -->
              <span i18n="@@bs-ai-generation-loading-text" mwc-typography class="mwc-text-sm-regular">{{generationType}} Generation is in progress, it may take few seconds...</span>
            </div>
          </div>
        </div>
    </div>
</div>

<ng-template #customSpinTpl>
  <div style="display: flex; justify-content: center; align-items: center; width: 100%; height: 100%;">
    <img src="assets/images/ai-loader.gif" alt="Loading" style="width: 40px; height: 40px;">
  </div>
</ng-template>

